var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":"","color":"indigo darken-2"},on:{"click":function($event){return _vm.printView(_vm.divId)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-printer")]),_vm._v(" Yazdır ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }